import React, { useState } from "react";
import { FaArrowRight, FaBars, FaTimes } from "react-icons/fa";

function Navbar({ logoSrc }) {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const closeMobileMenu = () => setIsMobileMenuOpen(false);
    const dispatchOpenForm = () => window.dispatchEvent(new Event("openContactForm"));

    return (
        <header className="relative w-full border-b border-[#E9E9E9] bg-white">
	            <div className="mx-auto flex h-[64px] w-full max-w-[1860px] items-center justify-between px-5 sm:px-6 md:h-[76px] lg:px-14">
	                <img
	                    src={logoSrc}
	                    alt="SimpliConnect"
	                    className="h-[40px] w-auto object-contain sm:h-[46px] md:h-[52px]"
	                />

	                <nav className="hidden items-center gap-16 text-[16px] md:flex lg:gap-24 lg:text-[18px]">
	                    <a href="#home" className="font-medium text-[#1466CB]">Home</a>
	                    <a href="#about" className="font-normal text-black">About Us</a>
	                    <a href="#services" className="font-normal text-black">Services</a>
	                    <a href="#contact" className="font-normal text-black">Contact Us</a>
	                </nav>

                <a
                    href="#contact"
                    onClick={(event) => {
                        event.preventDefault();
                        dispatchOpenForm();
                    }}
                    className="hidden items-center gap-3 rounded-[28px] px-7 py-3 text-[16px] font-normal leading-none text-black md:inline-flex lg:px-8 lg:text-[18px]"
                    style={{ backgroundColor: "#F6A52D" }}
                >
                    Get In Touch
                    <FaArrowRight aria-hidden="true" className="h-4 w-4" />
                </a>

                <button
                    type="button"
                    className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-[#D8E1EC] text-[#124C94] md:hidden"
                    aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
                    aria-expanded={isMobileMenuOpen}
                    onClick={() => setIsMobileMenuOpen((prev) => !prev)}
                >
                    {isMobileMenuOpen ? <FaTimes className="h-5 w-5" /> : <FaBars className="h-5 w-5" />}
                </button>
            </div>

            {isMobileMenuOpen && (
                <div className="border-t border-[#E9E9E9] bg-white md:hidden">
                    <nav className="mx-auto flex w-full max-w-[1860px] flex-col gap-1 px-5 py-4 text-[16px] sm:px-6">
                        <a href="#home" onClick={closeMobileMenu} className="py-2 font-medium text-[#1466CB]">Home</a>
                        <a href="#about" onClick={closeMobileMenu} className="py-2 text-black">About Us</a>
                        <a href="#services" onClick={closeMobileMenu} className="py-2 text-black">Services</a>
                        <a
                            href="#contact"
                            onClick={(event) => {
                                event.preventDefault();
                                dispatchOpenForm();
                                closeMobileMenu();
                            }}
                            className="py-2 text-black"
                        >
                            Contact Us
                        </a>
                        <a
                            href="#contact"
                            onClick={(event) => {
                                event.preventDefault();
                                dispatchOpenForm();
                                closeMobileMenu();
                            }}
                            className="mt-3 inline-flex w-fit items-center gap-2 rounded-[24px] px-5 py-2.5 text-[15px] font-semibold text-black"
                            style={{ backgroundColor: "#F6A52D" }}
                        >
                            Get In Touch
                            <FaArrowRight aria-hidden="true" className="h-4 w-4" />
                        </a>
                    </nav>
                </div>
            )}
        </header>
    );
}

export default Navbar;
